// extracted by mini-css-extract-plugin
export default {"overflow":"style_overflow__l1k66"};